export const AssessmentActionBarEN = {
    "assessmentActionBar": {
        "tab": {
            "detail": "Detail",
        },
        "item": {
            "delete": "Delete",
            "auditing": "History",
            "historyAction": "Activity History",
            "update": "Update",
            "confirm": "Confirm",
            "notConfirm": "Unconfirm",
            "back": "Go Back",
            "result": "Result",
            "evaluate": "Evaluate",
            "evaluateModal": "KPI Assessment Scoring",
            "time": "Time"
        },
        "message": {
            "deleteAsk": "Are you sure you want to delete?",
            "deleteTemplateAsk": "Are you sure you want to delete the assessment template?",
            "deleteSheetAsk": "Are you sure you want to delete the assessment form?",
        }
    }
}